import { http } from '@/utils/http'
export const QCBASE = window.$envUtils('VUE_APP_QC_SERVICE')
export const BPBASE = window.$envUtils('VUE_APP_BP_SERVICE')

/**
 * 查询模型管理列表
 * @param params
 * @returns {*|Promise<any>}
 */
export const modelManagerList = (params) => {
  return http.get(`${QCBASE}/mgr/model/qcModel`, { params })
}

/**
 * 查询模型分组
 * @param params
 * @returns {*|Promise<any>}
 */
export const modelGroupList = (params) => {
  return http.get(`${QCBASE}/mgr/modelgroup/qcModelGroup`, { params })
}

/**
 * 新增模型分组
 * @param params
 * @returns {*|Promise<any>}
 */
export const savemodelGroup = (params) => {
  return http.post(`${QCBASE}/mgr/modelgroup/qcModelGroup`, { params })
}

/**
 * 修改模型分组
 * @param params
 * @returns {*|Promise<any>}
 */
export const updatemodelgroup = (params) => {
  return http.put(`${QCBASE}/mgr/modelgroup/qcModelGroup`, { params })
}

/**
 * 修改模型分组
 * @param params
 * @returns {*|Promise<any>}
 */
export const removemodelgroup = (params) => {
  return http.delete(`${QCBASE}/mgr/modelgroup/qcModelGroup`, { params })
}

/**
 * 删除模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const removemodel = (params) => {
  return http.delete(`${QCBASE}/mgr/model/qcModel`, { params })
}

/**
 * 修改模型状态
 * @param params
 * @returns {*|Promise<any>}
 */
export const updateModelFlagPublish = (params) => {
  return http.put(`${QCBASE}/mgr/model/qcModels`, { params })
}

/**
 * 根据分组id查询模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const modelByGroupId = (params) => {
  return http.get(`${QCBASE}/mgr/model/qcModels`, { params })
}

/**
 * 添加语义模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const addModel = (data) => {
  return http.post(`${QCBASE}/mgr/model/qcModel`, { data })
}

/**
 * 修改语义模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const editModel = (data) => {
  return http.put(`${QCBASE}/mgr/model/qcModel`, { data })
}

/**
 * 根据id查询模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const queryModelByid = (params) => {
  return http.get(`${QCBASE}/mgr/model/qcModel/` + params)
}

/**
 * 测试语义模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const testModel = (data) => {
  return http.post(`${QCBASE}/mgr/model/testQcModel`, { data })
}

/**
 * 新增行为模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const saveBehavioralModel = (data) => {
  return http.post(`${QCBASE}/mgr/behavioralModel/bm/`, { data })
}

/**
 * 修改行为模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const updateBehavioralModel = (data) => {
  return http.put(`${QCBASE}/mgr/behavioralModel/bm/`, { data })
}

/**
 * 根据状态查询行为设置
 * @param params
 * @returns {*|Promise<any>}
 */
export const behaviorSettingsByStatus = (params) => {
  return http.get(`${QCBASE}/mgr/setting/behaviorSettings`, { params })
}

/**
 * 匹配词类
 * @param params
 * @returns {*|Promise<any>}
 */
export const querygetSemantic = (params) => {
  return http.get(`${QCBASE}/mgr/model/qcModel/getSemantic/` + params)
}

/**
 * 查询行为模型
 * @param params
 * @returns {*|Promise<any>}
 */
export const getBehavioralModelById = (data) => {
  return http.get(`${QCBASE}/mgr/behavioralModel/bm/` + data)
}

/**
 * 取客服组
 * @param params
 * @returns {*|Promise<any>}
 */
export const getCustomerGroup = () => {
  return http.get(`${BPBASE}/skillgroup/getSkillGroup`)
}
